import { NavbarI18n } from "@/locales/base.message.locales";

export const navbar: NavbarI18n = {
  menu: {
    about: "About Us",
    challenges: "Active</br>Challenges",
    billionaires: "Social</br>Billionaire Index",
    categories: "Categories",
    contact: "Contact",
    how_it_works: "How It</br>Works",
    impact: "Impact</br>Counter",
    partners: "Partners",
    living_lab: "Living</br>Lab",
    impact_board: "Social Impact</br>Board",
    transparency: "Transparency"
  },
  authenticated: {
    configuration: "Configuration",
    profile: "Profile",
    logout: {
      message: "You're sure to logout from application?!",
      title: "Logout",
      warn: "Warning"
    }
  },
  unauthenticated: {
    join_the_league: "JOIN THE LEAGUE",
    join: "JOIN"
  }
};
